import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import MessageDialog from 'src/components/MessageDialog';

import * as Actions from '../actions/exercise';
import { IUserAttr } from '../actions/session';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import SscenarioFactory, {
	IFetchTaskListParam,
} from '../scenario/ExerciseScenarioFactory';
import ImstatScenarioFactory from '../scenario/ImstatScenarioFactory';
import { isValid, MasterItemCode } from '../utils/MasterData';
import { Routes, Screens } from '../utils/Routes';

const styles = (theme: Theme) =>
	createStyles({
		paper: {
			marginTop: theme.spacing(4),
			padding: theme.spacing(3),
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(3),
			wordBreak: 'break-all',
		},
	});

interface IRouteParams {
	career_id: IFetchTaskListParam['careerID'];
	class_id: IFetchTaskListParam['classID'];
}

interface IRouteState {
	caller: Parameters<IProps['pushHistory']>[0];
}

interface IState {
	careerTitle: string;
	classTitle: string;
	errorStudyOrderdialogContent: string;
	errorStudyOrderdialogReplaceContent: string[];
	openErrorStudyOrderMessageDialog: boolean;
}

/**
 * 課題一覧画面
 */
class Exercise extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			careerTitle: '',
			classTitle: '',
			errorStudyOrderdialogContent: '',
			errorStudyOrderdialogReplaceContent: [],
			openErrorStudyOrderMessageDialog: false,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;
		const classID = this.props.match.params.class_id;

		// 課題一覧取得
		this.props
			.fetchTaskList(this.props.token, {
				careerID,
				classID,
				userAttr: this.props.userAttr,
			})
			.catch(() => {
				// 前画面に戻る
				const { state } = this.props.location;
				const caller =
					state && state.caller
						? state.caller
						: Routes.getPath(Screens.PERSONAL_PORTAL);
				this.props.pushHistory(caller);
			});

		// 一覧からタイトルを探す処理を定義
		interface IClass {
			careerID: string;
			classID: string;
			careerTitle: string;
			classTitle: string;
		}
		const setTitle = (classes: IClass[]) => {
			for (const c of classes) {
				if (c.careerID === careerID && c.classID === classID) {
					this.setState({
						careerTitle: c.careerTitle,
						classTitle: c.classTitle,
					});
					return true;
				}
			}
			return false;
		};

		// 一覧から受講順項目を探す処理を定義
		interface IStudyOrderClass {
			careerID: string;
			classID: string;
			uncompletedCareers: string;
			unrepresentedCareerCnt: string;
		}
		const setStudyOrderChkMsg = (classes: IStudyOrderClass[]) => {
			for (const c of classes) {
				if (c.careerID === careerID && c.classID === classID) {
					if (
						c.uncompletedCareers !== null &&
						c.uncompletedCareers !== ''
					) {
						if (c.unrepresentedCareerCnt !== '0') {
							this.setState({
								errorStudyOrderdialogContent: 'LMCM_E_15513',
							});
							this.setState({
								errorStudyOrderdialogReplaceContent: [
									c.uncompletedCareers,
									c.unrepresentedCareerCnt,
								],
							});
						} else {
							this.setState({
								errorStudyOrderdialogContent: 'LMCM_E_15512',
							});
							this.setState({
								errorStudyOrderdialogReplaceContent: [
									c.uncompletedCareers,
								],
							});
						}
					}
				}
			}
		};

		if (this.props.eLearnings.length > 0) {
			// imstatのeラーニング一覧があればそこから探す
			if (setTitle(this.props.eLearnings)) {
				setStudyOrderChkMsg(this.props.eLearnings);
				return;
			}
		}
		const isGD = isValid(MasterItemCode.CAREER_TYPE_CONTROL); // 集合研修/通信教育オプション
		if (isGD) {
			if (this.props.groupTrainings.length > 0) {
				// imstatの集合研修一覧があればそこから探す
				if (setTitle(this.props.groupTrainings)) {
					return;
				}
			}
			if (this.props.distanceLearnings.length > 0) {
				// imstatの通信教育一覧があればそこから探す
				if (setTitle(this.props.distanceLearnings)) {
					return;
				}
			}
		}

		// imstatの一覧にない場合は自分で取得してから探す
		this.props
			.doFetchOnGoingELearning(this.props.token, this.props.userAttr)
			.then(eLearnings => {
				if (setTitle(eLearnings) || !isGD) {
					setStudyOrderChkMsg(eLearnings);
					return;
				}
				this.props
					.doFetchOnGoingGroupTraining(
						this.props.token,
						this.props.userAttr
					)
					.then(groupTrainings => {
						if (setTitle(groupTrainings)) {
							return;
						}
						this.props
							.doFetchOnGoingDistanceLearning(
								this.props.token,
								this.props.userAttr
							)
							.then(distanceLearnings => {
								if (setTitle(distanceLearnings)) {
									return;
								}
								this.props
									.doFetchResultGroupTraining(
										this.props.token,
										this.props.userAttr
									)
									.then(g => {
										if (setTitle(g)) {
											return;
										}
										this.props
											.doFetchResultDistanceLearning(
												this.props.token,
												this.props.userAttr
											)
											.then(d => {
												setTitle(d);
											});
									});
							});
					});
			});
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.clearExerciseParams();
	}

	public render() {
		const { classes, tasks } = this.props;
		const careerID = this.props.match.params.career_id;
		const classID = this.props.match.params.class_id;

		return (
			<div className={classes.root}>
				<Grid container={true} spacing={3} alignItems="flex-end">
					<Grid item={true} xs={2}>
						<Typography variant="subtitle1" align="right">
							{i18n.t('Exercise_0001')}
						</Typography>
					</Grid>
					<Grid item={true}>
						<Typography variant="h5">
							{this.state.careerTitle}
						</Typography>
					</Grid>
				</Grid>
				<Grid container={true} spacing={3} alignItems="flex-end">
					<Grid item={true} xs={2}>
						<Typography variant="subtitle1" align="right">
							{i18n.t('Exercise_0002')}
						</Typography>
					</Grid>
					<Grid item={true}>
						<Typography variant="h5">
							{classID === 'CL000000'
								? i18n.t(this.state.classTitle, { ns: 'force' })
								: this.state.classTitle}
						</Typography>
					</Grid>
				</Grid>
				<Paper className={classes.paper}>
					<Typography variant="h6">
						{i18n.t('Exercise_0003')}
					</Typography>
					<Table>
						<colgroup>
							<col width={'25%'} />
							<col width={'15%'} />
							<col width={'30%'} />
							<col width={'18%'} />
							<col width={'12%'} />
						</colgroup>
						<TableHead>
							<TableRow>
								<TableCell size="small">
									{i18n.t('Exercise_0004')}
								</TableCell>
								<TableCell size="small">
									{i18n.t('Exercise_0005')}
								</TableCell>
								<TableCell size="small">
									{i18n.t('Exercise_0006')}
								</TableCell>
								<TableCell size="small">
									{i18n.t('Exercise_0007')}
								</TableCell>
								<TableCell size="small">
									{i18n.t('Exercise_0008')}
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{tasks.map((n, i) => {
								let pathname = Routes.getPath(
									Screens.PERSONAL_EXERCISE_FORM
								);
								pathname = pathname.replace(
									/\/:career_id\//,
									`/${careerID}/`
								);
								pathname = pathname.replace(
									/\/:class_id\//,
									`/${classID}/`
								);
								pathname = pathname.replace(
									/\/:seq\//,
									`/${n.seq}/`
								);
								pathname = pathname.replace(/\/:flg/, `/2`);
								pathname = pathname.replace(
									/\/:subjectStatusflg$/,
									`/${
										n.resultStatus === '提出済み'
											? '1'
											: '0'
									}`
								);
								let kikan = n.kikan;
								if (kikan && kikan.indexOf('～') !== -1) {
									kikan = kikan.replace(
										'～',
										i18n.t('～', {
											ns: 'force',
										})
									);
								}
								return (
									<TableRow key={i}>
										<TableCell
											size="small"
											component="th"
											scope="row"
										>
											{n.reportFileName}
										</TableCell>
										<TableCell size="small">
											{n.reportMstFlg}
										</TableCell>
										<TableCell size="small">
											{kikan}
										</TableCell>
										<TableCell size="small">
											{i18n.t(n.resultStatus, {
												ns: 'force',
											})}
										</TableCell>
										<TableCell size="small">
											{n.expired || (
												<Button
													variant="contained"
													color="primary"
													size="small"
													onClick={this.handleExercise(
														pathname
													)}
												>
													{i18n.t('Exercise_0009')}
												</Button>
											)}
											{!n.expired || (
												<Button
													variant="contained"
													color="primary"
													size="small"
													disabled={true}
												>
													{i18n.t('Exercise_0010')}
												</Button>
											)}
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</Paper>
				<MessageDialog
					open={this.state.openErrorStudyOrderMessageDialog}
					showCancelButton={false}
					title={i18n.t('Exercise_0012')}
					contents={[
						{
							content: this.state.errorStudyOrderdialogContent,
							replacements: this.state
								.errorStudyOrderdialogReplaceContent,
						},
					]}
					onClose={this.handleErrorMessageStudyOrderDialogClose}
					onClickOk={this.handleErrorMessageStudyOrderDialogClose}
				/>
			</div>
		);
	}

	protected handleExercise = (path: string) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		if (this.state.errorStudyOrderdialogContent !== '') {
			this.handleErrorMessageStudyOrderDialogOpen();
			return;
		}
		this.props.pushHistory(path);
	};

	/**
	 * 提出ボタンエラーメッセージクローズ
	 */
	protected handleErrorMessageStudyOrderDialogClose = () => {
		this.setState({ openErrorStudyOrderMessageDialog: false });
	};

	/**
	 * 提出ボタンエラーメッセージオープン
	 */
	protected handleErrorMessageStudyOrderDialogOpen = () => {
		this.setState({ openErrorStudyOrderMessageDialog: true });
	};
}

const mapStateToProps = (state: IRootState) => ({
	tasks: state.exercise.tasks,

	distanceLearnings: state.imstat.onGoingDistanceLearning.data,
	eLearnings: state.imstat.onGoingELearning.data,
	groupTrainings: state.imstat.onGoingGroupTraining.data,

	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearExerciseParams: () => dispatch(Actions.clearExerciseParams({})),
	doFetchOnGoingDistanceLearning: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchOnGoingDistanceLearning(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	doFetchOnGoingELearning: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchOnGoingELearning(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	doFetchOnGoingGroupTraining: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchOnGoingGroupTraining(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	doFetchResultDistanceLearning: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchResultDistanceLearning(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	doFetchResultGroupTraining: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchResultGroupTraining(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	fetchTaskList: (token: string, arg: IFetchTaskListParam) => {
		const s = SscenarioFactory.createFetchTaskList(dispatch, token);
		return s.run(arg);
	},
	pushHistory: (path: string) => dispatch(push(path)),
});

// tslint:disable-next-line: no-empty-interface
export interface IExerciseProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	IExerciseProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(Exercise);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<IExerciseProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/Exercise.tsx